/**
 * Menu Resolver
 *
 * Resolves which menu routes to display in the sidebar.
 * Priority: localStorage.menu_config (API-fetched) > routes.js defaults
 *
 * This module is the single integration point between the dynamic menu system
 * and the existing NavbarVertical/NavbarVerticalMenu components.
 */
import { menuConfigToRoutes } from "./components/bootstrap-components/MenuConfig/utils";
import defaultRoutes from "./routes";

/**
 * Resolve menu routes for the current user.
 * Returns a routes array in the format consumed by NavbarVerticalMenu.
 */
export function resolveMenuRoutes() {
  // Try to load API-fetched menu config from localStorage
  try {
    const menuConfigRaw = localStorage.getItem("menu_config");
    if (menuConfigRaw) {
      let menuConfig = JSON.parse(menuConfigRaw);
      // Handle double-stringified JSON
      if (typeof menuConfig === 'string') {
        menuConfig = JSON.parse(menuConfig);
      }
      if (Array.isArray(menuConfig) && menuConfig.length > 0) {
        const routes = menuConfigToRoutes(menuConfig);
        if (routes && routes.length > 0) {
          console.log("[MenuResolver] Using custom menu config from localStorage:", routes.length, "items");
          return routes;
        }
      }
      console.log("[MenuResolver] menu_config in localStorage but invalid/empty, falling back to defaults");
    } else {
      console.log("[MenuResolver] No menu_config in localStorage, using defaults");
    }
  } catch (error) {
    console.warn("[MenuResolver] Failed to parse menu_config from localStorage:", error);
  }

  // Fallback: use the hardcoded routes.js defaults
  if (!defaultRoutes) return [];
  // Filter out empty route objects (routes without a name are placeholders)
  const filtered = defaultRoutes.filter((route) => route && route.name);
  console.log("[MenuResolver] Using routes.js defaults:", filtered.length, "items");
  return filtered;
}
